import { Button, IconButton, TextField } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Delete from "@material-ui/icons/Delete";
import React from "react";
import { useTranslation } from "react-i18next";

export default function ShippingInformationTab({
  setEditedValues,
  editedValues,
  edit,
  setEditPackage,
  selectedWarehouse,
}) {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1} key={selectedWarehouse + "sit"}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          type="number"
          label={t("stockModule.totalWeight") + " (kg)"}
          inputProps={{ min: 0 }}
          defaultValue={edit?.StockItem?.PackingDetail?.weight || 0}
          onChange={(e, v) => {
            setEditedValues({
              ...editedValues,
              weight: e.target.value,
            });
          }}
          value={editedValues?.weight}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          label={t("stockModule.hsCodes")}
          multiline
          defaultValue={edit?.StockItem?.PackingDetail?.hsCodes
            ?.map((h) => h.code + "\n")
            .join("")}
          placeholder={"00000000\n111111111\netc."}
          onChange={(e, v) => {
            if (e && e.target && e.target.value) {
              setEditedValues({
                ...editedValues,
                hsCodes: e.target.value.split("\n").map((hs) => ({ code: hs })),
              });
              return;
            }
            var x = { ...editedValues, hsCodes: [] };
            setEditedValues({ ...x });
          }}
          value={editedValues?.hsCodes?.map((h) => h.code).join("\n")}
        />
      </Grid>
      <Grid container item xs={12} sm={6}>
        {editedValues?.packages
          ? [...(editedValues?.packages || [])].map((p, i) => (
              <Grid item xs={12} style={{ marginTop: 5 }} key={i}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setEditPackage({ ...p, index: i });
                  }}
                >
                  {i + 1}. {p.type} x {p.count}
                </Button>
                <IconButton
                  onClick={() => {
                    setEditedValues({
                      ...editedValues,
                      packages: editedValues.packages.filter(
                        (f, ii) => ii !== i
                      ),
                    });
                  }}
                >
                  <Delete />
                </IconButton>
              </Grid>
            ))
          : null}
        <Grid item xs={12} style={{ marginTop: 5 }}>
          <Button
            variant="outlined"
            onClick={() => {
              setEditPackage({});
            }}
          >
            {t("stockModule.addPackageDimensions")}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}
